<template>
  <div class="flex">
    <div
      :class="isOpen ? 'block' : 'hidden'"
      @click="clickOpen"
      class="
        fixed
        inset-0
        z-20
        transition-opacity
        bg-black
        opacity-50
        lg:hidden
      "
    ></div>
    <aside
      :class="isOpen ? 'translate-x-0 ease-out' : '-translate-x-full ease-in'"
      class="fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0"
    >
      <div class="mt-8 text-2xl px-5 font-semibold text-white">
        <span>Admin</span>
        <div v-if="isNotProduction" class="text-rose-600 text-xl">
          개발 테스트 페이지
        </div>
      </div>
      <nav class="mt-10 min-h-[80vh] overflow-auto">
        <div
          class="px-4"
          v-for="(sideBar, index) in sideBars" :key="index"
        >
          <div v-if="showSidebarItem(sideBar)">
            <router-link
              v-if="sideBar.type === 'own'"
              :to="sideBar.path"
              :class="[
                'flex items-center py-2 duration-200 border-l-4 text-decoration-none',
                $route.name === sideBar.routeName ? activeClass : inactiveClass
              ]"
              @click="handleNavClick(sideBar)"
            >
              <span class="mx-4">{{ sideBar.name }}</span>
            </router-link>
            <div v-else>
              <div
                @click="openSideBar(sideBar.routeName)"
                :class="[
                  'flex items-center py-2 duration-200 border-l-4 text-decoration-none border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100',
                  // @ts-ignore
                  sideBar.childrenRouteNames.includes($route.name) ? activeClass : inactiveClass
                ]"
              >
                <span class="mx-4">{{ sideBar.name }}</span>
              </div>
              <router-link
                v-for="(children, index) in sideBar.children"
                :key="index"
                :to="children.path"
                :class="[
                  store.state.navigation.openSideBarNames.includes(sideBar.routeName) ? '' : 'hidden',
                  'flex items-center py-2 duration-200 border-l-4 text-decoration-none',
                  $route.name === children.routeName ? activeClass : inactiveClass
                ]"
                @click="handleNavClick(children)"
              >
                <span class="ml-10">{{ children.name }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </nav>
      <div class="mx-4 mt-5">
        <router-link
          to="/login"
          class="px-6 py-2 mt-2 duration-200 border-l-4 text-decoration-none"
          :class="[inactiveClass]"
          @click="logout"
        >
          Log out
        </router-link>
      </div>
    </aside>
  </div>
</template>

<script setup lang="ts">
import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import api from "@/api/api";

const store = useStore()
const route = useRoute()

const isNotProduction = process.env.VUE_APP_ENV !== 'production'

const openSideBar = (name) => {
  store.commit("navigation/setOpenSideBarNames", name)
}

const showSidebarItem = (sideBar) => {
  return !!sideBar;
}

const logout = () => {
  // Vuex store 초기화
  store.commit("token/setToken", "")
  store.commit("token/setRefreshToken", "")
  store.commit("token/setIsSuperAdmin", false)
  store.commit("token/setRole", "")
  
  // localStorage 초기화
  localStorage.removeItem('ACCESS_TOKEN')
  localStorage.removeItem('REFRESH_TOKEN')
  localStorage.removeItem('IS_SUPER_ADMIN')
  localStorage.removeItem('ROLE')
  localStorage.removeItem('ADMIN_MENUS')
  localStorage.removeItem('KAKAO_MANAGEMENT_RESULT_FORMAT_SETTING')
}

// 네비게이션 클릭 핸들러 (새로고침 기능 추가)
const handleNavClick = (navItem) => {
  // 현재 페이지와 같은 페이지를 클릭한 경우
  if (route.name === navItem.routeName) {
    // 새로고침
    window.location.reload()
  } else {
    // 다른 페이지로 이동 (router-link의 기본 동작)
    // 이 경우는 router-link가 자동으로 처리
  }

  // 모바일에서 사이드바 닫기
  clickOpen()
}

const isOpen = computed(() => store.state.sideBar.isOpen)

const clickOpen = () => store.commit("sideBar/useSideBar")

const activeClass = ref(
  "bg-gray-600 bg-opacity-25 text-gray-100 border-gray-100"
);
const inactiveClass = ref(
  "border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100"
)

const filterMenusByRole = (menus) => {
  if (localStorage.getItem('ROLE') === 'ROLE_ADMIN') return menus
  return menus.filter((menu) => !['KakaoManagement', 'PtTeacherKakaoManagement'].includes(menu.routeName))
}

const sideBars = ref(filterMenusByRole(JSON.parse(localStorage.getItem('ADMIN_MENUS') || '[]')))

const loadMyMenus = () => {
  if (!localStorage.getItem('ACCESS_TOKEN')) return
  api.staff.myMenus().then((response) => {
    sideBars.value = filterMenusByRole(response.data || [])
    localStorage.setItem('ADMIN_MENUS', JSON.stringify(sideBars.value))
  })
}

onMounted(() => {
  loadMyMenus()
  window.addEventListener('admin-menus-updated', loadMyMenus)
})

onBeforeUnmount(() => window.removeEventListener('admin-menus-updated', loadMyMenus))

</script>
<style>
.log-out {
  position: absolute;
  bottom: 1rem;
}

.text-decoration-none {
  text-decoration: none;
}
</style>
